const cookieWrapper = document.querySelector('.js-cookies');
const cookieClose = document.querySelector('.js-cookie-accept');

if (typeof cookieClose != "undefined" && cookieClose != null) {

    cookieClose.addEventListener('click', () => {
        console.log('clicked')
        gsap.to(cookieWrapper, {
            y: '-100%'
        })
    })

}